import React, { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";

export function ProtectedRoute({ children }) {
  const { isLoading } = useAuth();
  const isAuthenticated =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  if (isLoading) {
    return <p>Carregando...</p>;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export function ProtectedRouteAdmin({ children, requiredRole }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <p>Carregando...</p>;
  }

  if (!user || user.accessType !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export function ProtectedRouteNormalUser({ children, requiredRole }) {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (!user) {
        console.log("Redirecionando para /dashboard (usuário não autenticado)");
        navigate("/dashboard", { replace: true });
      } else if (user.accessType === "AGENT") {
        console.log("Redirecionando AGENT para /cargas");
        navigate("/cargas", { replace: true });
      } else if (
        user.accessType !== requiredRole &&
        user.accessType !== "ADMIN"
      ) {
        console.log("Redirecionando para /dashboard (acesso negado)");
        navigate("/dashboard", { replace: true });
      }
    }
  }, [user, requiredRole, navigate, isLoading]);

  if (isLoading) {
    return <p>Carregando...</p>;
  }

  return user?.accessType === requiredRole || user?.accessType === "ADMIN"
    ? children
    : null;
}
